import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { decodeJwt } from '../../utils/tokenUtils';

export interface ICurrentUser {
  accessToken: string | null;
  refreshToken: string | null;
  roles: number[];
}

const extractRoles = (token: string | null): number[] => {
  if (!token) return [];
  const decoded = decodeJwt(token);
  if (!decoded || !Array.isArray(decoded.roles)) return [];
  return decoded.roles as number[];
};

const initialStateFunc = (): ICurrentUser => ({
  accessToken: localStorage.getItem('accessToken'),
  refreshToken: localStorage.getItem('refreshToken'),
  roles: extractRoles(localStorage.getItem('accessToken')),
});

const initialState = initialStateFunc();

type SetUserPayload = {
  accessToken: string;
  refreshToken: string;
  save?: boolean;
};

export const currentUser = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setUser: (state, { payload: { save, ...payload } }: PayloadAction<SetUserPayload>) => {
      if (save) {
        localStorage.setItem('accessToken', payload.accessToken);
        localStorage.setItem('refreshToken', payload.refreshToken);
      }
      return { ...payload, roles: extractRoles(payload.accessToken) };
    },

    refreshToken: (state, action: PayloadAction<{ accessToken: string | null }>) => {
      const { accessToken } = action.payload;

      if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
      } else {
        localStorage.removeItem('accessToken');
      }

      return { ...state, accessToken, roles: extractRoles(accessToken) };
    },

    logout: () => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      return initialStateFunc();
    },
  },
});

export const { setUser, logout, refreshToken } = currentUser.actions;
export default currentUser.reducer;
